import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

export const downloadRun = async (id: number) => {
  const res = await authFetch(`${API_BASE}/reports/runs/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "text/csv",
    },
  })

  const blob = await res.blob()
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", `report_${id}.csv`)

  document.body.appendChild(link)
  link.click()

  link.parentNode?.removeChild(link)
}
